<template>
  <div
    class="d-flex align-center"
    :style="[
      {
        backgroundColor: '#F4F4F4',
        padding: `8px`,
        borderRadius: $getScaledCssValue('12px'),
        boxShadow: `0 ${$getScaledCssValue('3px')} ${$getScaledCssValue(
          '6px'
        )} #00000029`
      },
      $breakpoints.mdAndUp && {
        padding: `${$getScaledCssValue('17px')} ${$getScaledCssValue('25px')}`
      }
    ]"
  >
  <input
      data-cy="list-section-search-input"
      style="outline: none;"
      :class="{
        'flex-grow-1 no-input-border': true,
        'text-p5': $breakpoints.smAndDown,
        'text-p3': $breakpoints.mdAndUp
      }"
      :placeholder="$t('enterSearchTermMsg')"
      v-model="innerValue"
      :style="{ minWidth: 0 }"
    />
    <v-icon large color="gray darken-2" @click="handleUndoClick">mdi-refresh</v-icon>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleUndoClick() {
      // Emit an event to inform the parent
      this.$emit('undo-clicked');
    }
  }
};
</script>

<style scoped>
</style>
